import { createClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey } from '/utils/supabase/info';

// Singleton Supabase client to avoid multiple instances
// Use globalThis to ensure true singleton across all modules
const SUPABASE_CLIENT_KEY = Symbol.for('__SUPABASE_CLIENT__');

export function getSupabaseClient() {
  // Check if client already exists in global scope
  if (!(globalThis as any)[SUPABASE_CLIENT_KEY]) {
    console.log('🔧 Creating new Supabase client instance');
    (globalThis as any)[SUPABASE_CLIENT_KEY] = createClient(
      `https://${projectId}.supabase.co`,
      publicAnonKey,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          storageKey: 'zsalako-auth-token',
          detectSessionInUrl: true,
        }
      }
    );
  } else {
    console.log('♻️ Reusing existing Supabase client instance');
  }
  return (globalThis as any)[SUPABASE_CLIENT_KEY];
}